import { Button, Divider, Grid, Tooltip, Typography } from '@material-ui/core';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import {
  Apartmen as ApartmenIcon,
  AccountBalance,
  Apartment,
  DateRange,
  Language,
  Link as LinkIcon,
  Pinterest,
  QuestionAnswer as QuestionAnswerIcon,
  Room as RoomIcon,
  Send as SendIcon,
  Twitter,
  YouTube,
} from '@material-ui/icons';
import Team from 'components/Icons/Team';
import { useStyles } from '@webapps/styles';
import Facebook from 'assets/facebook';
import Instagram from 'assets/instagram';
import LinkedIn from 'assets/linkedin';
import Tiktok from 'assets/tiktok';
import parse from 'html-react-parser';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { FormattedDate, FormattedMessage } from 'react-intl';

import theme from '../theme';

const {
  colors: { background },
} = theme;

const Presentation = ({
  email,
  foundationDate,
  headOffice,
  location,
  phone,
  presentation,
  publicPrivee,
  goodtoknow,
  whattheyseek,
  sector,
  sizeMax,
  sizeMin,
  siret,
  specialization,
  website,
  pinterest,
  twitter,
  linkedin,
  facebook,
  youtube,
  tiktok,
  instagram,
}) => {
  const {
    classes,
    css,
    global,
    cx,
    theme: { spacing },
  } = useStyles(styles);

  const copyUrl = (e) => {
    let url = window.location.href;
    e.value = url;
    navigator.clipboard
      .writeText(e.value)
      .then(() => {
        addToast({
          status: 'success',
          message: 'Lien copié',
        });
      })
      .catch(() => {
        addToast({
          status: 'error',
          message: 'Erreur lors de la copie ',
        });
      });
  };

  return (
    <>
      {presentation && typeof presentation === 'string' && (
        <Grid container className={classes.mainContainer}>
          <div className={cx(global.title, classes.title)}>
            Qui sont-ils ?
          </div>
          <div className={cx(global.infoText, classes.paragraphe)}>
            {parse(presentation)}
          </div>
        </Grid>
      )}
      {whattheyseek && typeof whattheyseek === 'string' && (
        <Grid container className={classes.mainContainer}>
          <div className={cx(global.title, classes.title)}>
            Ce qu'ils recherchent
          </div>
          <div className={cx(global.infoText, classes.paragraphe)}>
            {parse(whattheyseek)}
          </div>
        </Grid>
      )}
      {goodtoknow && typeof goodtoknow === 'string' && (
        <Grid container className={classes.mainContainer}>
          <div className={cx(global.title, classes.title)}>
            Bon à savoir
          </div>
          <div className={cx(global.infoText, classes.paragraphe)}>
           {parse(goodtoknow)}
          </div>
        </Grid>
      )}

      {/* BLOC "Collaborateurs" PC */}
      <Grid
        container
        className={cx(
          classes.mainContainer,
          css({
            display: 'none',
            flexWrap: 'nowrap',
            marginTop: 20,
          })
        )}
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
      >
        <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
          <div className={classes.smallSectionDiv}>
            <Apartment className={global.infoIcon} />
            <Typography
              variant="body1"
              className={global.title}
            >
              TYPE D'ORGANISME
            </Typography>
            <Typography
              variant="body1"
              className={global.subTitle}
            >
              Enseignement
            </Typography>
          </div>
        </Grid>
        <Divider
          classes={{
            root: css({ backgroundColor: '#C0D9FF', color: '#C0D9FF' }),
          }}
          orientation="vertical"
          flexItem
        />
        <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
          <div className={classes.smallSectionDiv}>
            <Team className={global.infoIcon} />
            <Typography
              variant="body1"
              className={global.title}
            >
              COLLABORATEURS
            </Typography>
            <Typography
              variant="body1"
              className={global.subTitle}
            >
              {sizeMin && sizeMax
                ? `${sizeMin} - ${sizeMax} Employés`
                : 'Non renseignées'}
            </Typography>
          </div>
        </Grid>
        <Divider
          classes={{
            root: css({ backgroundColor: '#C0D9FF', color: '#C0D9FF' }),
          }}
          orientation="vertical"
          flexItem
        />
        <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
          <div className={cx(classes.smallSectionDiv)}>
            <AccountBalance className={global.infoIcon} />
            <Typography
              variant="body1"
              className={global.title}
            >
              ORGANISME
            </Typography>
            <Typography
              variant="body1"
              className={global.subTitle}
            >
              {publicPrivee ? 'Public' : 'Privé'}
            </Typography>
          </div>
        </Grid>
        <Divider
          classes={{
            root: css({ backgroundColor: '#C0D9FF', color: '#C0D9FF' }),
          }}
          orientation="vertical"
          flexItem
        />
        <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
          <div className={classes.smallSectionDiv}>
            <DateRange className={global.infoIcon} />
            <Typography
              variant="body1"
              className={global.title}
            >
              FONDÉE EN
            </Typography>
            <Typography
              variant="body1"
              className={global.subTitle}
            >
              {foundationDate ? (
                <FormattedDate
                  day="numeric"
                  month="long"
                  value={foundationDate}
                  year="numeric"
                />
              ) : (
                'Non renseignées'
              )}
            </Typography>
          </div>
        </Grid>
      </Grid>
    </>
  );
};

const styles = ({ spacing }) => ({
  removeTopBorderRadius: {
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
  },
  container: {
    background,
    borderRadius: 10,
    padding: 20,
    '@media screen and (max-width: 768px)': {
      padding: 20,
    },
  },
  mainContainer: {
    background,
    padding: 20,
    borderRadius: 10,
    marginTop: 25,
    '@media screen and (max-width: 768px)': {
      borderRadius: 0,
    },  
  },
  infoContainer: {
    marginTop: spacing(3),
  },
  info: {
    '& > *': {
      marginBottom: spacing(1),
    },
  },
  infoTitle: {
    color: '#152652',
  },
  infoDetails: {
    color: '#5D75A8',
    marginBottom: spacing(2),
  },
  modifyLink: {
    color: '#152652',
    p: {
      overflowWrap: 'anywhere',
    },
    a: {
      textDecoration: 'none',
      color: '#0183FF',
    },
  },
  title: {
    display: 'flex',
    direction: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: '100%',
    paddingLeft: 8,
    borderLeft: '3px solid #0060F9',
  },
  iconsMobile: {
    display: 'flex',
    width: '100%',
    columnGap: 10,
  },
  iconsRS: {
    '@media (min-width:768px)': {
      display: 'none',
    },
  },
  smallSectionDiv: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    rowGap: '10px',
    padding: '20px',
    '@media (max-width: 1600px)': {
      padding: '20px',
    },
  },
  paragraphe: {
    marginTop: spacing(2),
    width: '100%',
    lineHeight: '20px',
    '& > p': {
      margin: 0
    }
  },
});

Presentation.propTypes = {
  foundationDate: PropTypes.string,
  headOffice: PropTypes.string,
  location: PropTypes.string,
  phone: PropTypes.string,
  presentation: PropTypes.string,
  sector: PropTypes.string,
  specialization: PropTypes.string,
  sizeMax: PropTypes.number,
  sizeMin: PropTypes.number,
  website: PropTypes.string,
  publicPrivee: PropTypes.bool,
  email: PropTypes.string,
};

export default Presentation;
